import styled from 'styled-components';
import { colors, radius } from '../../../../styles/tokens';

export const Container = styled.div`
  padding: 40px;
  min-height: 100%;

  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 1199px) {
    padding: 20px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media (max-width: 1199px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const PageTitle = styled.h1`
  font-size: 32px;
  font-weight: 800;
  color: ${colors.onSurface};
  letter-spacing: -0.01em;
  margin-bottom: 4px;
`;

export const PageSubtitle = styled.p`
  font-size: 14px;
  color: ${colors.onSurfaceVariant};
`;

export const AddButton = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;

  padding: 14px 28px;
  border: none;
  border-radius: ${radius.DEFAULT};
  cursor: pointer;

  background-color: ${colors.primary};
  color: ${colors.onPrimary};
  font-size: 13px;
  font-weight: 700;

  white-space: nowrap;

  &:hover {
    opacity: 0.9;
  }
`;

export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

export const SearchWrapper = styled.div`
  width: 100%;
  max-width: 340px;

  position: relative;
  display: flex;
  align-items: center;
`;

export const SearchIconWrapper = styled.div`
  position: absolute;
  left: 14px;
  display: flex;
  pointer-events: none;
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 42px;

  padding: 0 16px 0 44px;

  background-color: ${colors.surfaceContainer};
  border: none;
  border-radius: ${radius.full};

  font-size: 13px;
  color: ${colors.onSurface};

  &::placeholder {
    color: ${colors.onSurfaceVariant};
  }
`;

export const SelectWrapper = styled.div`
  width: 100%;
  max-width: 340px;
`;

export const Content = styled.div`
  flex: 1;

  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const MemberCell = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

export const Avatar = styled.img`
  width: 46px;
  height: 46px;
  border-radius: ${radius.DEFAULT};
  object-fit: cover;
`;

export const MemberName = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: ${colors.onSurface};
  display: block;
`;

export const MemberEmail = styled.span`
  font-size: 12px;
  color: ${colors.onSurfaceVariant};
  display: block;
  margin-bottom: 6px;
`;

interface StatusBadgeProps {
  active: boolean;
}

export const StatusBadge = styled.span<StatusBadgeProps>`
  display: inline-flex;
  align-items: center;
  gap: 6px;

  padding: 3px 10px;
  border-radius: ${radius.full};

  background-color: ${({ active }) =>
    active ? 'rgba(56, 193, 114, 0.15)' : 'rgba(255, 115, 81, 0.15)'};
  color: ${({ active }) => (active ? '#38c172' : colors.error)};
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;

  margin-right: 6px;
`;

export const PlatformBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;

  padding: 3px 10px;
  border-radius: ${radius.full};

  background-color: ${colors.tertiaryContainer};
  color: ${colors.onPrimary};
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
`;

export const ExpandToggle = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;

  background: transparent;
  border: none;
  cursor: pointer;

  font-size: 13px;
  color: ${colors.onSurface};

  &:disabled {
    color: ${colors.onSurfaceVariant};
    cursor: default;
  }
`;

export const ExpandRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  padding: 12px;
  border-radius: ${radius.DEFAULT};
  background-color: ${colors.surfaceContainerHigh}30;
`;

export const GymRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  padding: 8px 10px;
  border-radius: ${radius.DEFAULT};
  background-color: ${colors.surfaceContainer};
`;

export const GymRowInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  font-size: 12px;
  color: ${colors.onSurface};

  span {
    color: ${colors.onSurfaceVariant};
  }
`;

export const IconButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  color: ${colors.onSurfaceVariant};

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 4px;
  border-radius: ${radius.full};

  &:hover {
    background-color: ${colors.surfaceContainerHigh};
  }
`;
